import { createAction } from '@ngrx/store';
import { props } from '@ngrx/store';
import { MemberAlertModel } from 'src/app/model/member-alert.model';

export const RequestAction = createAction('[Member alert view] get data', props<{ accountId: number }>());
export const ResponseAction = createAction('[Member alert view] set data', props<{ payload: MemberAlertModel[] }>());

